import {
  Box,
  Button,
  Checkbox,
  Flex,
  Grid,
  LoadingOverlay,
  Select,
  Text,
  TextInput,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useEffect, useState } from "react";
import { formatDateTime } from "../../../../common/FormatDate/FormatDate";
import { repositoryPos } from "../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../model/MessageResponse";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
type Props = {
  setValuePrintOrderModal: any;
  setPrintOrderModalOpened: any;
  customerCheck: any;
};
export type PrintOrderModalType = {
  soHopDong: string | null;
  ngayBaoGia: string | null;
  ngayBanGiao: string | null;
  diachiBM: string | null;
  maSoThueBM: string | null;
  daiDienBM: string | null;
  chucVuBM: string | null;
  daiDienBB: string | null;
  chucVuBB: string | null;
  inGiaTien: boolean;
  inSoLuong: boolean;
  inKemDichVu: boolean;
};
const OptionPrintOrder = ({
  setValuePrintOrderModal,
  setPrintOrderModalOpened,
  customerCheck,
}: Props) => {
  const [optionHidden, setOptionHidden] = useState({
    isHopDong: true,
    isDonDatHang: true,
    isBenMua: true,
  });
  const [customerDetail, setCustomerDetail] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [isShowSoHopDong, setIsShowSoHopDong] = useState("Có");
  const form = useForm<PrintOrderModalType>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      soHopDong: null,
      ngayBaoGia: null,
      ngayBanGiao: null,
      diachiBM: null,
      maSoThueBM: null,
      daiDienBM: null,
      chucVuBM: null,
      daiDienBB: null,
      chucVuBB: null,
      inGiaTien: true,
      inSoLuong: true,
      inKemDichVu: true,
    },
    validate: {
      // soHopDong: (value: string | null) => {
      //     if (optionHidden.isHopDong && !value) {
      //         return "Số hợp đồng không được để trống";
      //     }
      // },

      ngayBaoGia: (value: string | null) => {
        if (optionHidden.isHopDong && !value && isShowSoHopDong === "Có") {
          return "Ngày báo giá không được để trống";
        }
      },
      diachiBM: (value: string | null) => {
        if (optionHidden.isDonDatHang && !value) {
          return "Địa chỉ bên mua không được để trống";
        }
      },
      ngayBanGiao: (value: string | null) => {
        if (!value) {
          return "Ngày bàn giao không được để trống";
        }
      },
      maSoThueBM: (value: string | null) => {
        if (optionHidden.isDonDatHang && !value) {
          return "Mã số thuế bên mua không được để trống";
        }
      },
      daiDienBM: (value: string | null) => {
        if (!value) {
          return "Đại diện bên mua không được để trống";
        }
      },
      chucVuBM: (value: string | null) => {
        if (!value) {
          return "Chức vụ bên mua không được để trống";
        }
      },
      daiDienBB: (value: string | null) => {
        if (optionHidden.isBenMua && !value) {
          return "Đại diện bên bán không được để trống";
        }
      },
      chucVuBB: (value: string | null) => {
        if (optionHidden.isBenMua && !value) {
          return "Chức vụ bên bán không được để trống";
        }
      },
    },
  });

  const handleCreatePrint = async (data: PrintOrderModalType) => {
    setValuePrintOrderModal({
      ...data,
      ngayBaoGia:
        data?.ngayBaoGia && optionHidden?.isHopDong
          ? formatDateTime(data?.ngayBaoGia)
          : null,
      ngayBanGiao: formatDateTime(data?.ngayBanGiao) ?? null,
    });
    // modals.closeAll();

    setPrintOrderModalOpened(true);
  };

  useEffect(() => {
    const handleOpenModal = async () => {
      setLoading(true);
      try {
        // Call API để lấy chi tiết khách hàng
        const customerDetailResponse = await repositoryPos.get<
          MessageResponse<any>
        >(`/api/v1/TblDmCustomer/get-detail?id=${customerCheck?.id}`);

        if (customerDetailResponse && customerDetailResponse.success) {
          const diachiBMResult = customerDetailResponse.data
            ? [
                customerDetailResponse.data.address,
                customerDetailResponse.data.communeName,
                customerDetailResponse.data.districtName,
                customerDetailResponse.data.provinceName,
              ]
                .filter(Boolean)
                .join(" - ")
            : customerCheck.address;
          const masothueResult =
            customerDetail?.taxCode || customerCheck.taxCode;
          form.setFieldValue("diachiBM", diachiBMResult ?? null);
          form.setFieldValue("maSoThueBM", masothueResult ?? null);
          setCustomerDetail(customerDetailResponse.data);
        }
      } catch (error) {
        console.error("Error fetching customer details:", error);
        NotificationExtension.Fails("Không thể tải thông tin khách hàng");
      } finally {
        setLoading(false);
      }
    };
    handleOpenModal();
  }, [customerCheck?.id]);

  return (
    <Box pos="relative">
      <LoadingOverlay visible={loading} zIndex={1000} />
      <form onSubmit={form.onSubmit((values) => handleCreatePrint(values))}>
        <Box
          style={{
            margin: "7px 3px",
          }}
        >
          <Box>
            <Flex align="center" justify="space-between">
              <Text fw={500}>Hợp đồng</Text>
              <Select
                data={[
                  { value: "Có", label: "Có" },
                  { value: "Không", label: "Không" },
                ]}
                value={isShowSoHopDong}
                onChange={(value) => {
                  setIsShowSoHopDong(value ?? "Không");
                  if (value === "Không") {
                    form.setFieldValue("soHopDong", null);
                  }
                }}
                w={100}
              />
            </Flex>
            <Box
              style={{
                marginLeft: "5px",
                display: optionHidden.isHopDong ? "block" : "none",
              }}
            >
              {isShowSoHopDong === "Có" && (
                <Flex direction="row" align="center" justify="space-between">
                  <div>
                    <Text size="md">Số hợp đồng</Text>
                  </div>
                  <div style={{ paddingTop: "4px" }}>
                    <TextInput
                      w={"250px"}
                      size="sm"
                      placeholder="Nhập số hợp đồng"
                      key={form.key("soHopDong")}
                      {...form.getInputProps("soHopDong")}
                    />
                  </div>
                </Flex>
              )}
              <Flex
                direction={"row"}
                align={"center"}
                justify={"space-between"}
              >
                <div>
                  <Text size="md">Ký ngày</Text>
                </div>
                <div style={{ paddingTop: "4px" }}>
                  <DatePickerInput
                    w={"250px"}
                    size="sm"
                    placeholder="Chọn ngày ký"
                    key={form.key("ngayBaoGia")}
                    {...form.getInputProps("ngayBaoGia")}
                    valueFormat="DD/MM/YYYY"
                    clearable
                  />
                </div>
              </Flex>
            </Box>
          </Box>

          <Box
            style={{
              marginTop: "7px",
            }}
          >
            <Flex direction={"row"} align={"center"} justify={"space-between"}>
              <div>
                <Text fw={500}>Ngày bàn giao, nghiệm thu</Text>
              </div>
              <div style={{ padding: "4px 0" }}>
                <DatePickerInput
                  w={"250px"}
                  size="sm"
                  placeholder="Chọn ngày bàn giao, nghiệm thu"
                  key={form.key("ngayBanGiao")}
                  {...form.getInputProps("ngayBanGiao")}
                  valueFormat="DD/MM/YYYY"
                  clearable
                />
              </div>
            </Flex>
          </Box>
          <Box style={{ marginTop: "7px" }}>
            <Flex direction={"row"} align={"center"} justify={"space-between"}>
              <div>
                <Text fw={500}>Bên mua</Text>
              </div>
              <div></div>
            </Flex>
            <Box
              style={{
                marginLeft: "5px",
              }}
            >
              <Flex
                direction={"row"}
                align={"center"}
                justify={"space-between"}
              >
                <div>
                  <Text size="md">Mã số thuế</Text>
                </div>
                <div style={{ padding: "4px 0" }}>
                  <TextInput
                    w={"250px"}
                    size="sm"
                    placeholder="Nhập mã số thuế"
                    key={form.key("maSoThueBM")}
                    {...form.getInputProps("maSoThueBM")}
                  />
                </div>
              </Flex>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"space-between"}
              >
                <div>
                  <Text size="md">Địa chỉ</Text>
                </div>
                <div style={{ padding: "4px 0" }}>
                  <TextInput
                    w={"250px"}
                    size="sm"
                    placeholder="Nhập địa chỉ"
                    key={form.key("diachiBM")}
                    {...form.getInputProps("diachiBM")}
                  />
                </div>
              </Flex>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"space-between"}
              >
                <div>
                  <Text size="md">Người đại diện</Text>
                </div>
                <div style={{ padding: "4px 0" }}>
                  <TextInput
                    w={"250px"}
                    size="sm"
                    placeholder="Nhập người đại diện"
                    key={form.key("daiDienBM")}
                    {...form.getInputProps("daiDienBM")}
                  />
                </div>
              </Flex>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"space-between"}
              >
                <div>
                  <Text size="md">Chức vụ</Text>
                </div>
                <div style={{ padding: "4px 0" }}>
                  <TextInput
                    w={"250px"}
                    size="sm"
                    placeholder="Nhập chức vụ"
                    key={form.key("chucVuBM")}
                    {...form.getInputProps("chucVuBM")}
                  />
                </div>
              </Flex>
            </Box>
          </Box>
          <Box style={{ marginTop: "7px" }}>
            <Flex direction={"row"} align={"center"} justify={"space-between"}>
              <div>
                <Text fw={500}>Bên bán</Text>
              </div>
            </Flex>
            <Box
              style={{
                marginLeft: "5px",
              }}
            >
              <Flex
                direction={"row"}
                align={"center"}
                justify={"space-between"}
              >
                <div>
                  <Text size="md">Đại diện</Text>
                </div>
                <div style={{ padding: "4px 0" }}>
                  <TextInput
                    w={"250px"}
                    size="sm"
                    placeholder="Nhập đại diện"
                    key={form.key("daiDienBB")}
                    {...form.getInputProps("daiDienBB")}
                  />
                </div>
              </Flex>
              <Flex
                direction={"row"}
                align={"center"}
                justify={"space-between"}
              >
                <div>
                  <Text size="md">Chức vụ</Text>
                </div>
                <div style={{ padding: "4px 0" }}>
                  <TextInput
                    w={"250px"}
                    size="sm"
                    placeholder="Nhập chức vụ"
                    key={form.key("chucVuBB")}
                    {...form.getInputProps("chucVuBB")}
                  />
                </div>
              </Flex>
            </Box>
          </Box>
          <Grid mt={"md"}>
            <Grid.Col span={4}>
              <Checkbox
                label="In kèm dịch vụ"
                checked={form.getValues().inKemDichVu}
                onChange={(event) => {
                  form.setFieldValue("inKemDichVu", !!event.target.checked);
                }}
              />
            </Grid.Col>
            <Grid.Col span={4}>
              <Checkbox
                label="In số lượng"
                checked={form.getValues().inSoLuong}
                onChange={(event) => {
                  form.setFieldValue("inSoLuong", !!event.target.checked);
                }}
              />
            </Grid.Col>
            <Grid.Col span={4}>
              <Checkbox
                label="In giá tiền trên phiếu"
                checked={form.getValues().inGiaTien}
                onChange={(event) => {
                  form.setFieldValue("inGiaTien", !!event.target.checked);
                }}
              />
            </Grid.Col>
          </Grid>
        </Box>
        <div style={{ textAlign: "center", marginTop: "6px" }}>
          <Button type="submit" variant="light">
            In phiếu
          </Button>
        </div>
      </form>
    </Box>
  );
};

export default OptionPrintOrder;
